import { useContext, useEffect, useMemo } from 'react';

import { useQueryClient } from 'query';
import MessageContext from 'query/MessageContext';

import { details } from '../data/queryKeyFactory';

const useDocuSigning = ({ data }: { data: any }) => {
  const queryClient = useQueryClient();

  const { showMessage } = useContext(MessageContext);

  const ioStatusBeforeDocuSigning = useMemo(
    () =>
      new URLSearchParams(window.location.search).get(
        'ioStatusBeforeDocuSigning'
      ),
    [window.location.search]
  );

  const statusId = data?.status?.id;

  useEffect(() => {
    if (Number(ioStatusBeforeDocuSigning) === statusId) {
      showMessage('The page will be automatically updated');

      const timeoutRequest = setInterval(() => {
        queryClient.invalidateQueries(details);
      }, 3000);

      return () => {
        window.clearInterval(timeoutRequest);
      };
    }
  }, [ioStatusBeforeDocuSigning, statusId]);
};

export default useDocuSigning;
